import { router, usePage } from "@inertiajs/react";
import { useId } from "react";
import { useTranslation } from "react-i18next";
import {
  NativeSelect,
  NativeSelectOption,
} from "@/components/ui/native-select";

export function LanguageChoice() {
  const {
    url,
    props: { i18n },
  } = usePage();
  const { t } = useTranslation();
  const id = useId();
  if (!i18n?.locale_choice_allowed) return null;
  return (
    <div className="flex flex-wrap items-center gap-3">
      <label htmlFor={id} className="text-sm font-medium">
        {t("common.language")}
      </label>
      <NativeSelect
        id={id}
        value={i18n.locale}
        onChange={(event) => {
          if (!url.startsWith("/") || url.startsWith("//")) return;
          const destination = new URL(url, "https://garageclerk.invalid");
          destination.searchParams.set("ui_locale", event.target.value);
          router.visit(
            `${destination.pathname}${destination.search}${destination.hash}`,
            { preserveState: true, preserveScroll: true, replace: true },
          );
        }}
      >
        <NativeSelectOption value="en">English</NativeSelectOption>
        <NativeSelectOption value="ro">Română</NativeSelectOption>
      </NativeSelect>
    </div>
  );
}
